import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2, Sparkles, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast, Toaster } from "sonner";

export default function CouponPage() {
  const { code } = useParams();
  const [coupon, setCoupon] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    api
      .publicCoupon(code)
      .then((r) => setCoupon(r.data))
      .catch((e) => setErr(e?.response?.data?.detail || "Coupon not found"))
      .finally(() => setLoading(false));
  }, [code]);

  const onCopy = () => {
    if (!coupon?.code) return;
    navigator.clipboard.writeText(coupon.code);
    toast.success("Coupon copied!");
  };

  if (loading)
    return (
      <div className="min-h-screen grid place-items-center bg-background">
        <div className="flex items-center gap-2 text-muted-foreground">
          <Loader2 className="h-5 w-5 animate-spin" /> Loading
        </div>
      </div>
    );

  if (err)
    return (
      <div className="min-h-screen grid place-items-center bg-background px-6">
        <div className="text-center max-w-md" data-testid="coupon-error">
          <Sparkles className="mx-auto h-10 w-10 text-muted-foreground" />
          <h1 className="font-heading text-3xl mt-3">Coupon not found</h1>
          <p className="text-muted-foreground mt-2">{err}</p>
        </div>
      </div>
    );

  return (
    <div className="min-h-screen grid place-items-center bg-background px-6">
      <Toaster richColors position="top-center" />
      <div className="max-w-md w-full text-center">
        <p className="uppercase tracking-[0.2em] text-xs text-muted-foreground">Your coupon</p>
        <h1 className="font-heading text-3xl md:text-4xl font-semibold mt-1" data-testid="coupon-prize-name">
          {coupon.gift_name}
        </h1>
        <div className="mt-6 inline-flex items-center gap-2 px-4 py-3 rounded-2xl bg-card border border-border shadow-[var(--shadow-card)]">
          <div className="font-mono tracking-widest text-xl md:text-2xl" data-testid="coupon-code">
            {coupon.code}
          </div>
          <Button variant="outline" size="icon" onClick={onCopy} data-testid="coupon-copy-button">
            <Copy className="h-4 w-4" />
          </Button>
        </div>
        {coupon.expires_at && (
          <p className="text-sm text-muted-foreground mt-3">
            Valid till {new Date(coupon.expires_at).toLocaleDateString()}
          </p>
        )}
        <p className="mt-4 text-sm" data-testid="coupon-status">
          Status: {coupon.is_redeemed ? "Redeemed" : "Unused"}
        </p>
      </div>
    </div>
  );
}
